/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  "use strict";

  Shopify.theme.jsTestimonials = {
    init: function init($section) {
      this.createSlider($section);
    },
    createSlider: function createSlider($section) {
      this.$sliderElement = $section.find('[data-slider]')
      if (!this.$sliderElement.length) return;

      var slider = this.$sliderElement.flickity({
        wrapAround: true,
        pageDots: true,
        freeScroll: false,
        prevNextButtons: false,
        cellAlign:'center'
      }); // Reset layout to avoid collapsing issues


      slider.on('settle.flickity', function () {
        this.adjustHeight()
      }.bind(this))

      setTimeout(function () {
        this.adjustHeight()
        slider.flickity('resize');
      }.bind(this), 1000);
    },
    adjustHeight() {
      let $blocks = this.$sliderElement.find('[data-testimonial-index]')
      let height = 0
      $blocks.each(function (index, block) {
        console.log(block.scrollHeight)
        if (height < block.scrollHeight) {
          height = block.scrollHeight
        }
      })
      $blocks.css('height', height)
    },
    blockSelect: function blockSelect($section, blockId) {
      var $slider = $section.find('[data-slider]');
      var index = $('#shopify-section-' + blockId).data('index');
      $slider.flickity('select', index, true, true);
    },
    unload: function unload($section) {
      var $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  };


  /******/
})()
  ;